import { render, staticRenderFns } from "./truckUtilitationDetail.vue?vue&type=template&id=5253d7df&scoped=true"
import script from "./truckUtilitationDetail.vue?vue&type=script&lang=js"
export * from "./truckUtilitationDetail.vue?vue&type=script&lang=js"
import style0 from "./truckUtilitationDetail.vue?vue&type=style&index=0&id=5253d7df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253d7df",
  null
  
)

export default component.exports